module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Wrapper Proposal"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isLoading) ? _c('Preloader') : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "Navigation"
  }, [_c('div', {
    staticClass: "Button-Third",
    on: {
      "click": _vm.backToBuilder
    }
  }, [_c('span', [_vm._v("Back to Builder")]), _vm._v(" "), _c('svg', {
    attrs: {
      "viewBox": "0 0 129 129"
    }
  }, [_c('path', {
    attrs: {
      "d": "m88.6,121.3c0.8,0.8 1.8,1.2 2.9,1.2s2.1-0.4 2.9-1.2c1.6-1.6 1.6-4.2 0-5.8l-51-51 51-51c1.6-1.6 1.6-4.2 0-5.8s-4.2-1.6-5.8,0l-54,53.9c-1.6,1.6-1.6,4.2 0,5.8l54,53.9z"
    }
  })])]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "Button",
    on: {
      "click": _vm.printPage
    }
  }, [_c('span', [_vm._v("Print as PDF")])]), _vm._v(" "), _c('div', {
    staticClass: "Button",
    class: [{
        "Button--Blue": _vm.proposal["Status"] === "draft"
      },
      {
        "Button--Orange": _vm.proposal["Status"] === "pending"
      },
      {
        "Button--Green": _vm.proposal["Status"] === "accepted"
      },
      {
        "Button--Purple": _vm.proposal["Status"] === "updated"
      },
      {
        "Button--Red": _vm.proposal["Status"] === "rejected"
      }
    ],
    on: {
      "click": _vm.toggleButton
    }
  }, [(_vm.proposal["Status"] === "draft") ? _c('span', [_vm._v("draft")]) : _vm._e(), _vm._v(" "), (_vm.proposal["Status"] === "pending") ? _c('span', [_vm._v("pending")]) : _vm._e(), _vm._v(" "), (_vm.proposal["Status"] === "rejected") ? _c('span', [_vm._v("rejected")]) : _vm._e(), _vm._v(" "), (_vm.proposal["Status"] === "updated") ? _c('span', [_vm._v("updated")]) : _vm._e(), _vm._v(" "), (_vm.proposal["Status"] === "accepted") ? _c('span', [_vm._v("accepted")]) : _vm._e()])])]), _vm._v(" "), _c('CoverPage', {
    attrs: {
      "projectInfo": _vm.proposal,
      "company": _vm.resolvedCompany,
      "logoPosition": _vm.proposal['Logo-Position'] || 'left'
    }
  }), _vm._v(" "), _c('Milestones', {
    attrs: {
      "proposal": _vm.proposal
    }
  }), _vm._v(" "), _c('ConfirmationPage', {
    attrs: {
      "company": _vm.resolvedCompany,
      "logoPosition": _vm.proposal['Logo-Position'] || 'left',
      "projectConfirmation": _vm.proposal['Project-Confirmation'],
      "projectNumber": _vm.proposal['Project-Number'],
      "projectDate": _vm.proposal['Date'],
      "projectType": _vm.proposal['Type']
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76121a12","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Proposal.vue
// module id = 168
// module chunks = 4